<form #formRef="ngForm" [ngClass]="{'sidebar-active': activeTab !== 'flowchart' && activeTab !== 'performance'}">
	<bb-page-header [backOnMobile]="['/adservices/adschedules']" [icon]="'bars-staggered'"
		[title]="entity && entity.title ? entity.title : ''">
		<ul class="tabs" *ngIf="entity">
			<li>
				<a [routerLink]="['/adservices/adschedule', activeId, 'metadata']" routerLinkActive=""
					[class.active]="activeTab === 'metadata'">
					<!-- hack to fix routerLinkActive after create new -->
					<i class="fa fa-tags"></i> {{ 'METADATA' | translate }}
				</a>
			</li>
		</ul>

		<bb-status *ngIf="entity" [(ngModel)]="entity.status" name="status" [labelOn]="'ENABLED' | translate"
			[labelOff]="'DISABLED' | translate"></bb-status>
	</bb-page-header>

	<div class="body-column tab-container">
		<adschedule-details-metadata [form]="form" [adschedule]="entity"
			[hidden]="activeTab !== 'metadata'"></adschedule-details-metadata>
	</div>
	<div class="body-column preview-container">
		<bb-entity-details [entity]="entity"></bb-entity-details>
	</div>
</form>

<bb-actions-bar (onSave)="save()" (onCancel)="cancel()" (onDelete)="delete()" [form]="form"
	[entity]="entity" [previewLink]="activeId === 'new' ? '' : (previewUrl + activeId + previewClipLength)">
</bb-actions-bar>
